module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Outdoor-activity.ebabd3d6.webp";